
export function SearchList() {

  return (
    <>
      <section className="sub-area">
        <h2>검색화면</h2>
      </section>
    </>
  );
}